module.exports = __webpack_public_path__ + "img/installationSiteImages-example.0b89ffb2.jpg";